<template>
  <div class="pcl">
    <div v-if="disabledHint" class="pcl-hint">{{ disabledHint }}</div>
    <template v-else>
      <div v-if="!items.length" class="pcl-empty">{{ emptyText }}</div>
      <div v-for="(it, idx) in items" :key="idx" class="pcl-card" @click="$emit('edit', it)">
        <div class="pcl-title-row">
          <span class="pcl-title">{{ resolve(titleField, it) || '—' }}</span>
          <button class="pcl-del" title="Șterge" @click.stop="$emit('delete', it)">
            <i class="dx-icon dx-icon-trash" />
          </button>
        </div>
        <div class="pcl-body">
          <div v-for="(f, fi) in fields" :key="fi" class="pcl-row">
            <span class="pcl-label">{{ f.label }}</span>
            <span class="pcl-val">{{ resolve(f, it) || '—' }}</span>
          </div>
        </div>
        <i class="dx-icon dx-icon-chevronright pcl-arrow" />
      </div>

      <button class="pcl-fab" :disabled="disableAdd" @click="$emit('add')">
        <i class="dx-icon dx-icon-plus" />
      </button>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

interface FieldDef {
  label?: string;
  key: string;
  format?: (value: any, item: any) => string | null;
}

export default defineComponent({
  name: "PamCardList",
  props: {
    items: { type: Array as PropType<any[]>, default: () => [] },
    titleField: { type: Object as PropType<FieldDef>, required: true },
    fields: { type: Array as PropType<FieldDef[]>, default: () => [] },
    emptyText: { type: String, default: "Nicio înregistrare." },
    disableAdd: { type: Boolean, default: false },
    disabledHint: { type: String, default: "" },
  },
  emits: ["add", "edit", "delete"],
  methods: {
    resolve(f: FieldDef, it: any): string | null {
      const v = it?.[f.key];
      return f.format ? f.format(v, it) : v == null ? null : String(v);
    },
  },
});
</script>

<style scoped>
.pcl { position: relative; height: 100%; overflow-y: auto; padding: 14px 12px 90px; display: flex; flex-direction: column; gap: 12px; background: #f4f6fb; }
.pcl-hint, .pcl-empty { text-align: center; color: #94a3b8; font-size: 14px; padding: 30px 12px; }
.pcl-card {
  position: relative;
  overflow: hidden;
  width: 100%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.07);
  padding: 14px 40px 14px 18px;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}
.pcl-card::before {
  content: "";
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 5px;
  background: linear-gradient(180deg, #ff2c21, #ff6a4a);
}
.pcl-card:active { transform: scale(0.985); box-shadow: 0 2px 8px rgba(15, 23, 42, 0.1); }
.pcl-title-row { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.pcl-title { font-size: 17px; font-weight: 800; color: #0f172a; letter-spacing: 0.2px; }
.pcl-del {
  flex-shrink: 0;
  width: 32px; height: 32px;
  display: flex; align-items: center; justify-content: center;
  border: none; border-radius: 50%;
  background: #fef2f2; color: #ef4444;
  cursor: pointer;
}
.pcl-del .dx-icon { font-size: 16px; }
.pcl-body { margin-top: 10px; display: flex; flex-direction: column; gap: 7px; }
.pcl-row { display: flex; justify-content: space-between; align-items: baseline; gap: 12px; font-size: 13px; }
.pcl-row + .pcl-row { border-top: 1px dashed #eef1f6; padding-top: 7px; }
.pcl-label { color: #94a3b8; font-weight: 500; }
.pcl-val { color: #1e293b; font-weight: 700; text-align: right; }
.pcl-arrow { position: absolute; right: 12px; top: 18px; color: #cbd5e1; font-size: 18px; }
.pcl-fab {
  position: fixed;
  right: 18px;
  bottom: 18px;
  z-index: 5;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: none;
  background: linear-gradient(135deg, #ff2c21, #ff6a4a);
  color: #fff;
  box-shadow: 0 6px 18px rgba(255, 44, 33, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.pcl-fab:disabled { opacity: 0.5; }
.pcl-fab .dx-icon { font-size: 24px; }
</style>
